import React, { useState } from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";
import { User, Building2 } from "lucide-react";
import Clients from "./Clients";
import Companies from "./Companies";

const ClientsAndCompanies = () => {
  const [activeTab, setActiveTab] = useState("clients");

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="clients" data-testid="tab-clients">
            <User className="h-4 w-4 mr-2" />
            Clients
          </TabsTrigger>
          <TabsTrigger value="companies" data-testid="tab-companies">
            <Building2 className="h-4 w-4 mr-2" />
            Companies
          </TabsTrigger>
        </TabsList>

        <TabsContent value="clients" className="mt-6">
          <Clients />
        </TabsContent>

        <TabsContent value="companies" className="mt-6">
          <Companies />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ClientsAndCompanies;
